import { LeadsBenchmarkTimeDivisionActionTypes } from './constants';

/**
 * @param {import('../reducer.defaultState').TimeDivision} timeDivision
 */
export const setLeadsBenchmarkTimeDivision = timeDivision => ({
  type: LeadsBenchmarkTimeDivisionActionTypes.SET_TIME_DIVISION,
  timeDivision,
});
